import { activeModule } from "../providers/active-module";
import * as CoreIcons from "./src/shared/assets/icons/icons";
import * as FourTimeIcons from "../4time/icons";
import * as IrsKomIcons from "../IrsKom/icons";
import * as Parhato2Icons from "../parhato2/icons";

const modulesIcons: Record<string, any> = {
  "4TIME": FourTimeIcons,
  IRSKOM: IrsKomIcons,
  PARHATO2: Parhato2Icons,
};

let Icons = CoreIcons;

const moduleName = activeModule;
if (modulesIcons[moduleName]) {
  Icons = { ...CoreIcons, ...modulesIcons[moduleName] };
}

export const {
  basketSvg,
  catalog,
  contacts,
  favorites,
  information,
  searchIcon,
  titleParhato,
  homeIcon,
  basketIcon,
  heartIcon,
  catalogIcon,
  personIcon,
  telegramIcon,
  telegramLogoRound,
} = Icons;

export default Icons;
